export const ListingFilters = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive'
}

export const PAGE_SIZES = [10, 15, 25, 50, 100]

export const DEFAULT_PER_PAGE = 10

export const ENABLED_COLUMNS_STORAGE_KEY = market => `listingManagerEnabledColums:${market}`
